import { api } from "./api";

export const DEV_AUTH_ENABLED =
  process.env.NODE_ENV === "development" && process.env.REACT_APP_DEV_AUTH === "true";

export async function fetchDevPersonas() {
  const r = await api.get("/auth/dev/personas");
  return r.data;
}

export async function devSwitchPersona(kind, personaId) {
  const r = await api.post("/auth/dev/switch", { kind, persona: personaId });
  return r.data;
}
